import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function OpenShoppingBags({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>OpenShoppingBags</title>
      <path
        d="M5 7H19V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V7Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10L9.75 10ZM15.75 10C15.75 9.58579 15.4142 9.25 15 9.25C14.5858 9.25 14.25 9.58579 14.25 10L15.75 10ZM9.75 11L9.75 10L8.25 10L8.25 11L9.75 11ZM14.25 10L14.25 11L15.75 11L15.75 10L14.25 10ZM12 13.25C10.7574 13.25 9.75 12.2426 9.75 11L8.25 11C8.25 13.0711 9.92893 14.75 12 14.75L12 13.25ZM12 14.75C14.0711 14.75 15.75 13.0711 15.75 11L14.25 11C14.25 12.2426 13.2426 13.25 12 13.25L12 14.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M7 4H17L19 7H5L7 4Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
